import { CheckIcon } from "@radix-ui/react-icons";
import { Progress } from "@radix-ui/themes";
import { FC } from "react";
import "./index.css";

type ProgressBarProps = {
  steps: number;
  currentStep: number;
};

export const ProgressBar: FC<ProgressBarProps> = (props) => {
  const { steps, currentStep } = props;
  const inactiveSteps = steps - currentStep;
  return (
    <div>
      <div className="progress-bar--wrapper">
        <div className="progress-bar--steps">
          <Progress value={currentStep} max={steps} size="3" color="green" />
        </div>
        <div className="progress-bar--icon-wrapper">
          {Array.from({ length: currentStep }).map((_, i) => (
            <div
              key={`active-${i}`}
              className="progress-bar--icon-container progress-bar--icon-container--active"
            >
              <CheckIcon color="#fff" />
            </div>
          ))}
          {Array.from({ length: inactiveSteps }).map((_, i) => (
            <div key={`inactive-${i}`} className="progress-bar--icon-container">
              <CheckIcon color="#fff" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
